const DG_CONFIG = {
  ROW_PER_PAGE: 20,
  PAGE_SIZE_OPTIONS: [
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
    { label: "All", value: -1 },
  ],
  OVERLAY: {
    variant: "skeleton",
    noRowsVariant: "skeleton",
  },
  HEIGHT_STYLES: {
    height: "60vh",
    minHeight: "250px",
    maxHeight: "632px",
    width: "100%",
    minWidth: "100px",
    // maxWidth: isSidebarOpen === true ? "calc(100vw - 330px)" : "calc(100vw - 140px)"
  },
};

export default DG_CONFIG;
